import React from "react";

import Drawer from "@material-ui/core/Drawer";
import { useTheme } from "@material-ui/core/styles";

import { Body, Grabber, Head, Sheet, Title } from "./styles";

interface BottomSheetProps {
    open: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    children: React.ReactNode;
}

/*
* Нижний лист для узкого вьюпорта: на мобильном сюда уезжает то, что на десктопе живёт в
* сайдбаре или поповере (выбор категории, управление меню, действия позиции, список селекта).
*
* ⚠️ z-index поднят над модальным слоем. Лист открывается и **из диалога** — селект кита стоит
* в модалках промокода, категории и копирования позиции, — а Drawer по умолчанию ниже Dialog
* (1200 против 1300), то есть лист уезжал бы под открытую модалку вместе со своей подложкой.
* */
export const BottomSheet = ({ open, onClose, title, children }: BottomSheetProps) => {
    const theme = useTheme();

    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            style={{ zIndex: theme.zIndex.modal + 1 }}
            PaperProps={{ style: { background: "transparent", boxShadow: "none" } }}
        >
            <Sheet>
                <Grabber />
                {title && (
                    <Head>
                        <Title>{title}</Title>
                    </Head>
                )}
                <Body>{children}</Body>
            </Sheet>
        </Drawer>
    );
};
